import moment from 'moment';
import React from 'react'
import { highlightSearchMatch } from './AnnouncementCard';

const ReservationAnnouncementLabel = ({
  announcement,
  isAllTasksDone,
  annIcon,
  labelClasses,
}: {
  announcement: any;
  isAllTasksDone: boolean;
  annIcon?: string;
  labelClasses?: string;
}) => {
  const reservationZoneTitle =
    typeof announcement?.reservation_zone === "string"
      ? announcement.reservation_zone
      : announcement?.reservation_zone?.title || "";

  const reservationSummaryItems = [
    {
      key: "time",
      value: announcement?.scheduling?.startTime
        ? announcement.scheduling.startTime
        : "",
      dir: "ltr" as const,
      className: "shrink-0",
    },
    {
      key: "party",
      value:
        announcement?.number_of_people || announcement?.number_of_people === 0
          ? `${announcement.number_of_people}P`
          : "",
      dir: "ltr" as const,
      className: "shrink-0",
    },
    {
      key: "zone",
      value: reservationZoneTitle,
      className: "min-w-0 truncate max-w-[100px]",
    },
    {
      key: "client",
      value: announcement?.client_name || "",
      className: "min-w-0 truncate max-w-[70px]",
    },
    {
      key: "phone",
      value: announcement?.phone || "",
      dir: "ltr" as const,
      className: "shrink-0",
    },
  ].filter((item) => item.value);
  return (
    <div className="flex min-w-0 flex-1 items-center gap-2 overflow-hidden">
      {annIcon && (
        <div className="w-[20px] h-[20px] shrink-0">
          <img
            src={annIcon}
            alt="icon"
            className="w-full h-full object-contain"
          />
        </div>
      )}

      <div className="flex flex-wrap items-center gap-2 ">
        {reservationSummaryItems.map((item, index) => (
          <React.Fragment key={item.key}>
            {index === 3 && (
              <div className="w-[1px] h-[22px] shrink-0 bg-gray40" />
            )}
            <span
              dir={item.dir || "auto"}
              title={item.value}
              className={` font-medium leading-none text-base text-black ${item.className || ""} ${
                isAllTasksDone ? "line-through" : ""
              } ${labelClasses || ""}`}
            >
              {item.value}
            </span>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default ReservationAnnouncementLabel